/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICookieComplianceViewProps } from '@msdyn365-commerce-modules/cookie-compliance';

const CookieComplianceView: React.FC<ICookieComplianceViewProps> = props => {
    const { CookieComplianceBanner, Content, acceptButton, text, links } = props;

    return (
        <Module {...CookieComplianceBanner}>
            <Node {...Content}>
                {text}
                {links}
            </Node>
            {acceptButton}
        </Module>
    );
};
export default CookieComplianceView;
